import { getWebKeyboardInset, subscribeWebKeyboardInset } from '@shared-ui/platform/keyboard/web-keyboard-inset'
import { useSyncExternalStore } from 'react'

export function useKeyboardOverlap(): number {
  return useSyncExternalStore(subscribeWebKeyboardInset, getWebKeyboardInset, () => 0)
}
